import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {LeadSourceService} from './services/lead-source.service';
import {LeadEndpointService} from './services/lead-endpoint.service';
import {ProductFormsService} from './services/product-forms.service';

@NgModule({
  imports: [
    CommonModule,
  ],
  providers: [
    LeadSourceService,
    LeadEndpointService,
    ProductFormsService,
  ]
})
export class CoreModule {
}
